import '@ant-design/v5-patch-for-react-19';
import { setupHttpInterceptors } from '@api/http-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './app/global.css';
import '@i18n/index';

import { App } from './App';

setupHttpInterceptors();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
